export default {"src":"/_next/static/media/ic_cbox_off.55ce02fd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};